export enum InvoiceType {
  INVOICE = 'INVOICE',
  CANCELLATION_INVOICE = 'CANCELLATION_INVOICE',
}

export enum InvoiceSearchMode {
  INVOICE_NUMBER = 'INVOICE_NUMBER',
  RESIDENT = 'RESIDENT',
}
